import { type LocationQuery } from 'vue-router';

type SortOrder = 'asc' | 'desc';

export const utilsMixins = {
  getBoxImageProxyUrl(imageUrl: string) {
    const boxRegexPattern = new RegExp('^https?://on.box.com');
    const isBoxUrl = boxRegexPattern.test(imageUrl);
    const proxy = import.meta.env.VITE_APP_boxProxy;

    if (!isBoxUrl || !proxy) {
      return imageUrl;
    }

    return imageUrl.replace(boxRegexPattern, proxy);
  },
  getStartUrl() {
    let startURL;

    if (window.location.hash !== '#/') {
      startURL = window.location.pathname + window.location.hash;
    }

    return startURL;
  },
  extractSizeFromDescription(input?: string, separator = ' '): string {
    const oneSize = 'One Size';

    if (input) {
      if (input.toLowerCase().includes(oneSize.toLowerCase())) {
        return oneSize;
      }

      const splits = input.trim().split(separator);

      return splits[splits.length - 1].includes('-')
        ? `${splits[splits.length - 2]}  ${splits[splits.length - 1]}`
        : splits[splits.length - 1];
    }

    return '';
  },
  safeParseNumber(number: any) {
    return Number(number) || 0;
  },
  scrollToId(reference: string) {
    const targetElement = document.getElementById(reference)?.getBoundingClientRect();

    if (targetElement) {
      window.scrollTo(window.scrollX, targetElement?.y + window.scrollY);
    }
  },
  // Tries to scroll to the element having id tag as the scrollTarget
  attemptAutoScroll(scrollTarget: string, query?: LocationQuery): void {
    if (query && query['autoScroll'] === 'true') {
      this.scrollToId(scrollTarget);
    }
  },
  compareDates(a: string, b: string, sortOrder: SortOrder = 'asc'): number {
    if (sortOrder === 'asc') {
      return new Date(a).valueOf() - new Date(b).valueOf();
    }

    return new Date(b).valueOf() - new Date(a).valueOf();
  },
  calculateDivHeight(selectors: string[], additionalOffset = 0) {
    let totalHeight = 0;

    for (const selector of selectors) {
      const element = document.querySelector<HTMLElement>(selector);
      totalHeight += element?.offsetHeight ?? 0;
    }

    return totalHeight + additionalOffset;
  },
};
